import { render, staticRenderFns } from "./ProductAccordionItem.vue?vue&type=template&id=5faf6980&scoped=true&"
import script from "./ProductAccordionItem.vue?vue&type=script&lang=js&"
export * from "./ProductAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf6980",
  null
  
)

export default component.exports